var $doc = $(document);
var $win = $(window);
var tablet = 1024;

$doc.ready(function () {

    var options = [{page: "home", expression:"overcube.com/$", menu: "Women"}, {page: "women", expression:"/women-", menu: "Women"}, {page: "men", expression:"/men-", menu: "Men"}, {page: "kids", expression:"/kids-", menu: "Kids"}];
    for( var i = 0; i < options.length; i++){
      var patt = new RegExp(options[i].expression);
      var regex_test = patt.test(window.location.href);
      if ( regex_test && options[i].page != "home" ) {
        Cookies.set('current_menu_item', options[i].menu);
        if (options[i].page == 'kids' && ( localStorage.getItem('selected_gender') == null || localStorage.getItem('selected_gender') == 'undefined')){
          localStorage.setItem('selected_gender', 'women');
        }else if(options[i].page != 'kids') {
          localStorage.setItem('selected_gender', options[i].page);
        }
      } else if (( Cookies.get('current_menu_item') == null || Cookies.get('current_menu_item') == "undefined" ) && regex_test && options[i].page == "home"){
        Cookies.set('current_menu_item', options[i].menu);
      }
    }
    
    var patt = new RegExp("/products/");
    var regex_test = patt.test(window.location.href);
    if ( regex_test) {
      Cookies.set('current_menu_item', selected_menu);
    }

  	function set_current_menu_item(item) {
      if ( Cookies.get('current_menu_item') != null || Cookies.get('current_menu_item') != "undefined" ) {

        $("li").find(`[data-title='${item}']`).parent("li").addClass("current");
      	Cookies.set('current_menu_item', item);

      }

    }

  	$('.nav-primary > ul > li').on( "click", function() {

      var current_menu_item = $(this).children('a').data( "title" );

      set_current_menu_item(current_menu_item)

    });

    $('.logo').on("click",function(){
      var homepage_redirect = localStorage.getItem('selected_gender');
      if (homepage_redirect != null){
        if(homepage_redirect != 'kids'){
          $('.logo').children('a').attr('href', "/pages/" + homepage_redirect + "-homepage");
        }else{
          $('.logo').children('a').attr('href', "/collections/" + homepage_redirect + "-all");
        }
        
      }
    })

    $('.mobile_logo').on("click",function(){
      var homepage_redirect = localStorage.getItem('selected_gender');
      if (homepage_redirect != null){
        if(homepage_redirect != 'kids'){
          $('.mobile_logo').attr('href', "/pages/" + homepage_redirect + "-homepage");
        }else{
          $('.mobile_logo').attr('href', "/collections/" + homepage_redirect + "-all");
        }
        
      }
    })

	var stored_menu_item = Cookies.get('current_menu_item');

  	set_current_menu_item(stored_menu_item);

    setTimeout(function() {
        var $listItems = $('.nav-primary > ul > li:first-child #dropdown_country_list_mobile');

        var $siblingLinks = $listItems.closest('.nav-primary__link').parent().siblings('li').find('.sublink');

        $siblingLinks.each(function() {
            $siblingLinks.clone().addClass('js-cloned').appendTo($(this))
        })

    }, 2000);

    $win.on('load resize', function() {
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vhorg = window.innerHeight - 87;
        let vh = vhorg * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    /** 
    $win.on('load', function() {

      	// On hovering main menu items remove current class, add back in current class to stored menu selection
        var currentLi = $('.nav-primary li.current');
        $('.nav-primary > ul > li > a').hover(
          function() {
            currentLi.removeClass('current');
          }, function() {
          }
        );

        $('.nav-primary').hover(
          function() {
          }, function() {
            // if current class hasn't already been applied to another element, add it back to the current element
            if (!($('.nav-primary li.current')[0])) {
              currentLi.addClass('current');
            }
            // set_current_menu_item(stored_menu_item);
          }
        );

    });
    */

    $('.js-mobile-menu').on('click', function(event) {
        event.preventDefault();

      	var current_menu_item = Cookies.get('current_menu_item').toLowerCase();

      	$( "li.current" ).each(function() {

          var menu_item = $(this).children('a').data( "title" ).toLowerCase();

          if (current_menu_item != menu_item ) {
          	$(this).removeClass('current');
          }

        });

        $('.nav-primary').add($(this)).toggleClass('open');

      	if (Cookies.get('current_menu_item') == null || Cookies.get('current_menu_item') == "undefined") {

          $("a[data-title='{&quot;women&quot;=&gt;&quot;Women&quot;, &quot;men&quot;=&gt;&quot;Men&quot;, &quot;kids&quot;=&gt;&quot;Kids&quot;, &quot;boys&quot;=&gt;&quot;Boys&quot;, &quot;girls&quot;=&gt;&quot;Girls&quot;}']").parent("li").addClass("current");

        }

        $(".mega-menu-lazy-load-images").find(".mega-menu-lazy-image").each(function(){
          $(this).attr("src",$(this).attr("data-src"));
          $(this).attr("srcset",$(this).attr("data-srcset"));
        });
        $(".mega-menu-lazy-load-images").removeClass("mega-menu-lazy-load-images");
    });

    $(".mega-menu-lazy-load-images").hover(function(){
      $(this).find(".mega-menu-lazy-image").each(function(){
        $(this).removeClass(".mega-menu-lazy-image");
        $(this).attr("src",$(this).attr("data-src"));
        $(this).attr("srcset",$(this).attr("data-srcset"));
      }),
      $(this).removeClass("mega-menu-lazy-load-images");
    });

    $('.nav-primary__link').on('click', function(event) {
        if ($win.width() < tablet) {
            event.preventDefault();

            $(this).closest('li').addClass('current').siblings().removeClass('current');
        }
    });

    $('.menu__item a').on('click', function(event) {
        var $this      = $(this);
        var $parent    = $this.closest('li');
        var $dropdown  = $parent.find('.menu__dropdown');

        if ($win.width() < tablet) {
            if ($dropdown.length) {
                event.preventDefault();

                $parent.addClass('menu__item--clicked');
            };
        };
    });

    
    var $menuDropdown   = $('.nav__dropdown > ul > li .menu__dropdown');

    $menuDropdown.each(function() {
        var $this = $(this);
        var parentTitle = $this.closest('.menu__item').find('> a').text();

        $this.prepend('<li class="link_title_container"><a href="#" class="link_title"><span>'+parentTitle+'</span></a></li>');
    });

    $doc.on('click', '.link_title', function(event) {
        event.preventDefault();

        $(this).closest('.menu__item--clicked').removeClass('menu__item--clicked')
    });

    $('.menu__item').each(function() {
        var $ddImage = $(this).find('.dropdown_image');

        if ($ddImage.is(':visible')) {
            $(this).addClass('menu__item--alt');
        };
    });
  
    // Check if nav dropdown is open on page load and add spacing at the top
    if ($('.nav-primary > ul').find('> .current').length) {
      $('.header-section').addClass('js-push-down');
    }  

    // Show cart count
    $('.add_to_cart').click(function() {
      $('.cart_count').show();
    });

});
